import React, { ReactNode } from 'react';
import { Box, Stack, Text, List, ListItem, TextLink } from '@origin-digital/ods-core';
import { StaticPerkAccordionType } from '../../typings';

const BatteryStarterPerkSummary: ReactNode = <Text weight="medium">Important info</Text>;

const BatteryStarterPerkBody: React.ReactNode = (
  <Stack space="medium">
    <Box>
      <Text weight="medium">To be eligible for this Energy Plan: </Text>
      <List space="xxsmall">
        <ListItem>
          <Text>Your solar PV system must be net metered.</Text>
        </ListItem>
        <ListItem>
          <Text>
            Your solar PV system must not exceed 50KW of inverter capacity or must be limited to
            50KW of export.
          </Text>
        </ListItem>
        <ListItem>
          <Text>you must not be receiving a feed-in tariff under any government scheme.</Text>
        </ListItem>
        <ListItem>
          <Text>
            Check with your battery brand if you want to manually export from your battery.
          </Text>
        </ListItem>
        <ListItem>
          <Text>
            <TextLink
              data-id="battery-starter-terms-link"
              href="https://www.originenergy.com.au/solar/battery-plans/starter/" // TODO is this correct link ?
              target="_blank"
            >
              Learn more about how Battery Starter works here.
            </TextLink>
          </Text>
        </ListItem>
      </List>
    </Box>
  </Stack>
);

export const BatteryStarterPerk: StaticPerkAccordionType = {
  accordionIcon:
    'https://www.originenergy.com.au/cdn/images/originenergy/image/upload/pictograms/pictogram_battery_wall.svg',
  accordionSummary: BatteryStarterPerkSummary,
  accordionBody: BatteryStarterPerkBody,
  accordionDataId: 'battery-starter-perk',
  expanded: true,
  synced: true,
};
